module.exports = __webpack_public_path__ + "static/cintas-fr-logo-6a776f568e76aee6e0ecd6001beefb41.jpg";